// Entity types
export * from './board-template/board-template.js'
export * from './theme/theme.js'
export * from './board/board.js'
export * from './group/group.js'
export * from './play-group/play-group.js'

// Entities, resolvers, subscribers
import {
  entities as BoardTemplateEntities,
  resolvers as BoardTemplateResolvers,
  subscribers as BoardTemplateSubscribers
} from './board-template/index.js'
import {
  entities as ThemeEntities,
  resolvers as ThemeResolvers,
  subscribers as ThemeSubscribers
} from './theme/index.js'
import {
  entities as BoardEntities,
  resolvers as BoardResolvers,
  subscribers as BoardSubscribers
} from './board/index.js'
import { entities as GroupEntities, resolvers as GroupResolvers } from './group/index.js'
import {
  entities as PlayGroupEntities,
  resolvers as PlayGroupResolvers,
  subscribers as PlayGroupSubscribers
} from './play-group/index.js'
import { resolvers as IntegrationAnalysisQuery } from './analysis/index.js'
import { entities as BoardFavoriteEntities, resolvers as BoardFavoriteResolvers } from './board-favorite/index.js'
import { subscribers as PermissionSubscriber } from './permission/index.js'

export const entities = [
  ...BoardTemplateEntities,
  ...ThemeEntities,
  ...BoardEntities,
  ...GroupEntities,
  ...PlayGroupEntities,
  ...BoardFavoriteEntities
]

export const subscribers = [
  ...BoardTemplateSubscribers,
  ...ThemeSubscribers,
  ...BoardSubscribers,
  ...PlayGroupSubscribers,
  ...PermissionSubscriber
]

export const schema = {
  resolverClasses: [
    ...BoardTemplateResolvers,
    ...ThemeResolvers,
    ...BoardResolvers,
    ...GroupResolvers,
    ...PlayGroupResolvers,
    ...IntegrationAnalysisQuery,
    ...BoardFavoriteResolvers
  ]
}
